document.addEventListener('DOMContentLoaded', () => {
  // Check if the body has the class .pageAanpak
  const pageAanpakDiv = document.querySelector('.pageAanpak__row');

  if (pageAanpakDiv) {
    const sectionText = document.querySelector('.pageAanpak__textAppend');
    const appendHereParagraph = sectionText.querySelector('.appendHere');
    const kvScoresParagraph = document.querySelector('.kvScores');

    // Ensure all required elements are found
    if (sectionText && appendHereParagraph && kvScoresParagraph) {
      // Move kvScoresParagraph after appendHereParagraph
      appendHereParagraph.insertAdjacentElement('afterend', kvScoresParagraph);
    } else {
      // eslint-disable-next-line no-console
      console.error('One or more elements not found. Check your selectors.');
    }
  } else {
    // Page does not have .pageAanpak — script not needed on this page.
  }
});
